module.exports = __webpack_public_path__ + "img/android-samsung-internet-install-menu.51bedd98.png";